// 认证相关API接口
import { API_CONFIG, showApiMessage, showApiError } from '../config/api';
import { handleApiError, checkResponseError } from '../utils/errorHandler';

const API_BASE_URL = API_CONFIG.BASE_URL;

// 通用请求函数
const request = async (url, options = {}, showToast = true) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  // 添加token到请求头
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  try {
    const response = await fetch(`${API_BASE_URL}${url}`, config);
    const data = await response.json();
    
    // 使用新的错误处理工具
    const errorCheck = checkResponseError(response, data);
    if (errorCheck.isError) {
      const result = handleApiError(new Error(errorCheck.message), data, showToast);
      if (result.shouldRedirect) {
        return;
      }
      // 如果已经处理了错误，直接抛出，避免重复处理
      throw new Error(errorCheck.message);
    }

    if (!response.ok) {
      const errorMessage = data.message || '请求失败';
      // 只在没有使用handleApiError的情况下显示错误
      if (showToast) {
        showApiError(errorMessage);
      }
      throw new Error(errorMessage);
    }

    // 显示成功消息
    if (showToast && data.message) {
      // 操作成功，不显示提示
    }

    return data;
  } catch (error) {
    console.error('API请求错误:', error);
    // 避免重复显示错误，只在特定情况下显示
    if (showToast && !error.message.includes('请求失败') && !error.message.includes('认证错误') && !error.message.includes('登录已过期')) {
      showApiError(error);
    }
    throw error;
  }
};

// 用户注册
export const register = async (userData) => {
  return request('/auth/register', {
    method: 'POST',
    body: JSON.stringify(userData),
  });
};

// 用户登录
export const login = async (credentials) => {
  return request('/auth/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  });
};

// 用户登出
export const logout = async () => {
  return request('/auth/logout', {
    method: 'POST',
  });
};

// 获取当前用户信息
export const getCurrentUser = async () => {
  return request('/auth/me');
};

// 刷新token
export const refreshToken = async () => {
  return request('/auth/refresh', {
    method: 'POST',
  });
};

// 修改密码
export const changePassword = async (passwordData) => {
  return request('/auth/change-password', {
    method: 'POST',
    body: JSON.stringify(passwordData),
  });
};

// 微信登录
export const wechatLogin = async (code) => {
  alert('即将请求 /api/auth/wechat-login，code: ' + code);
  console.log('即将请求 /api/auth/wechat-login，code:', code);
  return request('/auth/wechat-login', {
    method: 'POST',
    body: JSON.stringify({ code }),
  });
};

// 获取微信用户信息
export const getWechatUserInfo = async () => {
  return request('/auth/wechat-user-info');
};

// 微信授权检查
export const checkWechatAuth = async () => {
  return request('/auth/wechat-check');
}; 